// import React, { useEffect, useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import Spinner from "../../components/Spinner/Spinner";
// import privateApi from "../../apis/privateApi";
// import Notification from "../../components/Notification/Notification";

// import "./BudgetLineDetail.css";

// const BudgetLineDetail = () => {
//     const location = useLocation();
//     const navigate = useNavigate();

//     const budgetLine = location?.state?.budgetLine;

//     const [data, setData] = useState(null);
//     const [loading, setLoading] = useState(false);

//     const [notification, setNotification] = useState({
//         show: false,
//         message: "",
//         type: "info"
//     });

//     const handleNotificationClose = () =>
//         setNotification(prev => ({ ...prev, show: false }));


//     useEffect(() => {

//         const fetchBudgetLine = async () => {

//             if (!budgetLine?._id) return;

//             setLoading(true);

//             try {
//                 const res = await privateApi.get(`/api/budget-lines/${budgetLine._id}`);
//                 setData(res?.data?.data);
//             } catch (err) {
//                 setNotification({
//                     show: true,
//                     message:
//                         err.response?.data?.message ||
//                         "Failed to load budget line details.",
//                     type: "error"
//                 });

//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchBudgetLine();
//     }, [budgetLine?._id]);

//     if (loading) return <Spinner loadingInfo="Loading Budget Line Details..." />;

//     if (!budgetLine) return <p>No budget line selected.</p>;

//     return (
//         <div className="budgetline-detail">

//             <h2>Budget Line Detail</h2>

//             <Notification
//                 show={notification.show}
//                 message={notification.message}
//                 type={notification.type}
//                 onClose={handleNotificationClose}
//             />

//             <div className="budgetline-detail-card">

//                 <div className="budgetline-detail-row">
//                     <span className="label">{data?.stateId?.name || data?.lgaId?.name}</span>
//                 </div>

//                 <div className="budgetline-detail-row">
//                     <span className="label">Administrative Unit</span>
//                     <span className="value">
//                         {data?.administrativeUnitId?.code} - {data?.administrativeUnitId?.description}
//                     </span>
//                 </div>

//                 <div className="budgetline-detail-row">
//                     <span className="label">Programme</span>
//                     <span className="value">
//                         {data?.programmeId?.code} - {data?.programmeId?.description}
//                     </span>
//                 </div>

//                 <div className="budgetline-detail-row">
//                     <span className="label">Economic Segment</span>
//                     <span className="value">
//                         {data?.economicSegmentId?.code} - {data?.economicSegmentId?.description}
//                     </span>
//                 </div>

//                 <div className="budgetline-detail-row">
//                     <span className="label">Functional Segment</span>
//                     <span className="value">
//                         {data?.functionalSegmentId?.code} - {data?.functionalSegmentId?.description}
//                     </span>
//                 </div>

//                 <div className="budgetline-detail-row">
//                     <span className="label">Fund</span>
//                     <span className="value">
//                         {data?.fundId?.code} - {data?.fundId?.description}
//                     </span>
//                 </div>

//                 <div className="budgetline-detail-row">
//                     <span className="label">Transactions</span>
//                     <span className="value">
//                         {data?.transactionsCount}
//                     </span>
//                 </div>

//                 <div className="budgetline-detail-row">
//                     <span className="label">Spent Amount</span>
//                     <span className="value amount">
//                         ₦{Number(data?.spentAmount || 0).toLocaleString()}
//                     </span>
//                 </div>

//                 <div className="budgetline-detail-row">
//                     <span className="label">Amount</span>
//                     <span className="value amount">
//                         ₦{Number(data?.amount || 0).toLocaleString()}
//                     </span>
//                 </div>

//             </div>

//             <div className="budgetline-detail-actions">
//                 {data?.budgetStatus === 'draft' && <Link to={'/budget-lines/edit'} state={{ budgetLine: data }} className="budgetline-detail-edit-btn">Edit</Link>}
//                 {(data?.budgetStatus === 'approved' || data?.budgetStatus === 'locked') && <Link to={'/transactions/create'} state={{ budgetLine: data }} className="budgetline-detail-edit-btn">Add Transaction</Link>}
//                 {/* {(data?.budgetStatus === 'approved' || data?.budgetStatus === 'locked') && <Link to={'/budget-line/transactions'} state={{ budgetLine: data }} className="budgetline-detail-edit-btn">View Transactions</Link>} */}
//                 {data?.transactionsCount > 0 && <Link to={'/budget-line/transactions'} state={{ budgetLine: data }} className="budgetline-detail-edit-btn">View Transactions</Link>}
//                 <button onClick={() => navigate(-1)} className="budgetline-detail-back-btn">Back</button>
//             </div>

//         </div>
//     );
// };

// export default BudgetLineDetail;

import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Spinner from "../../components/Spinner/Spinner";
import privateApi from "../../apis/privateApi";
import Notification from "../../components/Notification/Notification";
import "./BudgetLineDetail.css";

const BudgetLineDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const budgetLine = location?.state?.budgetLine;

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState({ show: false, message: "", type: "info" });

    useEffect(() => {
        if (!budgetLine?._id) return;
        (async () => {
            setLoading(true);
            try {
                const res = await privateApi.get(`/api/budget-lines/${budgetLine._id}`);
                setData(res?.data?.data);
            } catch (err) {
                setNotification({
                    show: true,
                    message: err.response?.data?.message || "Failed to load budget line details.",
                    type: "error",
                });
            } finally {
                setLoading(false);
            }
        })();
    }, [budgetLine?._id]);

    if (loading) return <Spinner loadingInfo="Loading Budget Line Details…" />;
    if (!budgetLine) return (
        <div className="bgt-page-centered">
            <p style={{ color: "var(--muted)", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                No budget line selected.
            </p>
        </div>
    );

    const locationName = data?.stateId?.name || data?.lgaId?.name || "—";

    const Field = ({ label, children }) => (
        <div className="bld-field">
            <span className="bld-field-label">{label}</span>
            <span className="bld-field-value">{children || "—"}</span>
        </div>
    );

    const segLabel = (seg) => seg ? `${seg.code} — ${seg.description}` : "—";

    return (
        <div className="bgt-page-centered">
            <div className="bld-inner">
                <h1 className="bgt-page-title">Budget Line Detail</h1>

                <Notification show={notification.show} message={notification.message}
                    type={notification.type} onClose={() => setNotification(p => ({ ...p, show: false }))} />

                <div className="bld-card">
                    {/* Card top */}
                    <div className="bld-card-top">
                        <div>
                            <div className="bld-location">{locationName}</div>
                        </div>
                        <div className="bld-card-top-right">
                            {data?.budgetStatus && (
                                <span className={`bgt-status ${data.budgetStatus}`}>
                                    <span className="bgt-status-dot" />
                                    {data.budgetStatus}
                                </span>
                            )}
                        </div>
                    </div>

                    {/* Amount highlight bar */}
                    <div className="bld-amount-bar">
                        <div className="bld-amount-item">
                            <div className="bld-amount-label">Budgeted Amount</div>
                            <div className="bld-amount-value">₦{Number(data?.amount || 0).toLocaleString()}</div>
                        </div>
                        <div className="bld-amount-item">
                            <div className="bld-amount-label">Spent Amount</div>
                            <div className="bld-amount-value spent">₦{Number(data?.spentAmount || 0).toLocaleString()}</div>
                        </div>
                        <div className="bld-amount-item">
                            <div className="bld-amount-label">Transactions</div>
                            <div className="bld-amount-value count">{data?.transactionsCount ?? 0}</div>
                        </div>
                    </div>

                    {/* Segment fields */}
                    <div className="bld-fields">
                        <Field label="Administrative Unit">{segLabel(data?.administrativeUnitId)}</Field>
                        <Field label="Programme">{segLabel(data?.programmeId)}</Field>
                        <Field label="Economic Segment">{segLabel(data?.economicSegmentId)}</Field>
                        <Field label="Functional Segment">{segLabel(data?.functionalSegmentId)}</Field>
                        <Field label="Fund">{segLabel(data?.fundId)}</Field>
                    </div>

                    {/* Actions */}
                    <div className="bld-actions">
                        <button className="bgt-btn bgt-btn-secondary" onClick={() => navigate(-1)}>← Back</button>

                        {data?.budgetStatus === "draft" && (
                            <Link className="bgt-btn bgt-btn-primary"
                                to="/budget-lines/edit" state={{ budgetLine: data }}>
                                ✏ Edit
                            </Link>
                        )}
                        {(data?.budgetStatus === "approved") && (
                            <Link className="bgt-btn bgt-btn-gold"
                                to="/transactions/create" state={{ budgetLine: data }}>
                                + Add Transaction
                            </Link>
                        )}
                        {data?.transactionsCount > 0 && (
                            <Link className="bgt-btn bgt-btn-ghost"
                                to="/budget-line/transactions" state={{ budgetLine: data }}>
                                View Transactions
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BudgetLineDetail;
